export const checkValueInRange = ({
  bottomValue,
  topValue,
  valueToCheck,
}: {
  bottomValue: number;
  topValue: number;
  valueToCheck: number;
}) => valueToCheck <= topValue && valueToCheck >= bottomValue;
